// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// PropTypes and DefaultProps
const defaultProps = {
  width: '20px',
}

const propTypes = {
  width: PropTypes.string,
}

// Component
function IconAttachedFile({ width }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30.001 36"
      width={width}
    >
      <rect fill="#5badfa" width="25" height="31" rx="3" />
      <path
        d="M23.439,21.268V7.111a2.565,2.565,0,0,0-2.562-2.562H12.812v9.161a3.844,3.844,0,0,1-7.687,0V8.2a1.281,1.281,0,1,1,2.562,0v5.509a1.281,1.281,0,0,0,2.562,0V3.844a1.282,1.282,0,0,0-2.53-.29,1.28,1.28,0,0,1-1.344.989c-.032,0-.065.005-.1.005H5.125A2.565,2.565,0,0,0,2.562,7.111V27.674a2.565,2.565,0,0,0,2.562,2.562H20.877a2.565,2.565,0,0,0,2.562-2.562,1.281,1.281,0,0,1,2.562,0A5.131,5.131,0,0,1,20.877,32.8H5.125A5.131,5.131,0,0,1,0,27.674V7.111A5.131,5.131,0,0,1,5.125,1.986H5.6a3.845,3.845,0,0,1,6.731,0h8.544A5.131,5.131,0,0,1,26,7.111V21.268a1.281,1.281,0,0,1-2.562,0ZM6.406,25.111a1.281,1.281,0,0,0,0,2.562h9.289a1.281,1.281,0,1,0,0-2.562Zm14.413-3.78a1.281,1.281,0,0,0-1.281-1.281H6.406a1.281,1.281,0,0,0,0,2.562H19.538A1.281,1.281,0,0,0,20.819,21.332Zm-1.281-6.278H16.592a1.281,1.281,0,0,0,0,2.562h2.947a1.281,1.281,0,0,0,0-2.562Zm0-5.061H16.592a1.281,1.281,0,0,0,0,2.562h2.947a1.281,1.281,0,0,0,0-2.562Zm0,0"
        transform="translate(4 3.201)"
      />
    </svg>
  )
}

IconAttachedFile.defaultProps = defaultProps
IconAttachedFile.propTypes = propTypes

export default IconAttachedFile
